var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _line, _line2, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.676 122.373C135.926 121.144 133.074 117.374 131.902 116.056L133.53 114.415C134.785 115.827 137.048 118.623 137.88 119.985L136.676 122.373Z",
    fill: "#F99502"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.87 110.065C122.276 108.45 119.361 107.145 116.211 106.4L116.696 104.069C120.101 104.874 123.232 106.28 126.001 108.004L124.87 110.065Z",
    fill: "#59D150"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.648 105.64C103.796 106.048 100.824 106.978 97.774 108.579L96.7829 106.438C100.046 104.725 103.251 103.717 106.35 103.274L106.648 105.64Z",
    fill: "#0066CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9691 113.851C88.8125 114.892 87.6498 116.04 86.4833 117.303L86.4712 117.316L86.4587 117.329C85.4831 118.322 84.4007 119.328 83.2275 120.314L81.8385 118.441C82.9519 117.504 83.9766 116.552 84.8972 115.616C86.1057 114.308 87.315 113.114 88.5228 112.027L89.9691 113.851Z",
    fill: "#59D150"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2066 125.281C73.7143 126.679 71.0245 127.859 68.2164 128.653L67.6413 126.345C70.2625 125.604 72.7951 124.496 75.1622 123.169L76.2066 125.281Z",
    fill: "#F99502"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7054 129.8C56.8768 129.67 54.017 129.034 51.2025 127.751L52.085 125.556C54.6352 126.719 57.2269 127.296 59.8023 127.415L59.7054 129.8Z",
    fill: "#0066CC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4165 122.673C41.4488 120.804 39.5525 118.523 37.7525 115.783L39.5893 114.415C41.3002 117.019 43.0833 119.157 44.9087 120.891L43.4165 122.673Z",
    fill: "#F99502"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5264 108.33C32.9263 107.02 31.7673 104.448 31.2 102.998L33.2692 102.08C33.8203 103.489 34.9613 106.018 35.541 107.283L33.5264 108.33Z",
    fill: "#0066CC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.664 86.9384L71.9915 98.1975C73.9089 98.9596 76.0741 98.7661 77.826 97.6762L99.295 84.3192C99.716 84.0572 100.239 84.0203 100.693 84.2205L132.342 98.1873C132.732 98.3591 133.03 98.6883 133.162 99.0928L147.873 144.018C148.275 145.244 147.044 146.371 145.858 145.863L103.667 127.804C101.928 127.059 99.9498 127.109 98.2504 127.942L56.3733 148.451C55.9219 148.672 55.3899 148.653 54.9562 148.399L11.5541 123.012C10.7273 122.529 10.5594 121.405 11.2089 120.701L42.0074 87.3152C42.4284 86.8589 43.087 86.7091 43.664 86.9384Z",
    stroke: "#0066CC",
    strokeWidth: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 55.7106,
    y1: 149.162,
    x2: 73.2407,
    y2: 97.0825,
    stroke: "#0066CC",
    strokeWidth: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 100.946,
    y1: 127.458,
    x2: 97.6846,
    y2: 81.6774,
    stroke: "#0066CC",
    strokeWidth: 5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M116.88 41.4703C116.88 59.1422 99.6062 85.3535 83.0405 105.988C81.8627 107.455 79.6457 107.469 78.4522 106.015C65.1927 89.8577 44.64 62.0281 44.64 41.4703C44.64 22.9851 60.8115 8 80.76 8C100.709 8 116.88 22.9851 116.88 41.4703Z",
    fill: "#0066CC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1171 65.2768V64.964C77.1543 61.6449 77.5257 59.0035 78.2314 57.0398C78.9371 55.0761 79.94 53.4861 81.24 52.2696C82.54 51.0532 84.1 49.9323 85.92 48.9071C87.0157 48.2815 88 47.5429 88.8729 46.6914C89.7457 45.8225 90.4329 44.8233 90.9343 43.6938C91.4543 42.5642 91.7143 41.313 91.7143 39.9402C91.7143 38.2372 91.2871 36.7601 90.4329 35.5089C89.5786 34.2577 88.4364 33.2932 87.0064 32.6155C85.5764 31.9378 83.9886 31.5989 82.2429 31.5989C80.72 31.5989 79.2529 31.8943 77.8414 32.4852C76.43 33.076 75.2507 34.0057 74.3036 35.2743C73.3564 36.5428 72.8086 38.2024 72.66 40.253H65.64C65.7072 38.9165 65.9113 37.6671 66.2521 36.5049C66.6648 35.0982 67.2779 33.8191 68.0914 32.6676C69.5957 30.5649 71.5736 28.9575 74.025 27.8453C76.495 26.7331 79.2343 26.1771 82.2429 26.1771C85.5114 26.1771 88.3529 26.7853 90.7671 28.0017C93.2 29.2182 95.0757 30.8864 96.3943 33.0065C97.7314 35.1266 98.4 37.5421 98.4 40.253C98.4 42.1645 98.0843 43.8936 97.4529 45.4402C96.84 46.9868 95.9486 48.3684 94.7786 49.5848C93.6271 50.8012 92.2343 51.8787 90.6 52.817C88.9657 53.7728 87.6564 54.7807 86.6721 55.8408C85.6879 56.8834 84.9729 58.1259 84.5271 59.5683C84.0814 61.0106 83.84 62.8092 83.8029 64.964V65.2768H77.1171ZM80.6829 80.7082C79.3086 80.7082 78.1293 80.2477 77.145 79.3267C76.1607 78.4057 75.6686 77.3022 75.6686 76.0162C75.6686 74.7303 76.1607 73.6268 77.145 72.7058C78.1293 71.7848 79.3086 71.3243 80.6829 71.3243C82.0571 71.3243 83.2364 71.7848 84.2207 72.7058C85.205 73.6268 85.6971 74.7303 85.6971 76.0162C85.6971 76.8677 85.465 77.6497 85.0007 78.3622C84.555 79.0747 83.9514 79.6482 83.19 80.0826C82.4471 80.4997 81.6114 80.7082 80.6829 80.7082Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFound);
export default __webpack_public_path__ + "static/media/page-not-found.8fa529116cde7591c7d15df40a26c919.svg";
export { ForwardRef as ReactComponent };